export const tabHeader = {
  materail: "Material Details",
  truck: "Trucking Details",
};
